import React, { ReactNode } from "react";
import { useHistory } from "react-router-dom";

import { Button } from "../Button";
import styles from "./BackButton.module.scss";

interface Props {
  id?: string;
  children: ReactNode;
  disabled?: boolean;
}

export const BackButton = ({ id, children, disabled }: Props) => {
  const history = useHistory();

  const handleGoBack = () => {
    history.goBack();
  };

  return (
    <Button
      id={id}
      disabled={disabled}
      onClick={handleGoBack}
      type="link"
      leading={<i className={`icon icon-arrow-left ${styles.backButton__icon}`} />}
    >
      {children}
    </Button>
  );
};
